import { onUserTaskTemplateActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { DefaultTaskActivityCard } from "./DefaultTaskActivityCard";

interface Props {
  defaultTaskId: number
  config: server.dto.ActivityPanelConfig
}

export const DefaultTaskActivityPanel = (props: Props) => {
  return <ActivityPanel<server.dto.UserTaskTemplateActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.UserTaskTemplate.ListActivity({ itemId: props.defaultTaskId, page, perPage })}
    renderActivity={(activity => <DefaultTaskActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onUserTaskTemplateActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.defaultTaskId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === site.currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}